module.exports = __webpack_public_path__ + "static/media/coffee.db03abba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/coffee.jpg
// module id = 566
// module chunks = 6